import {
    Box,
    Button,
    Checkbox,
    Flex,
    Heading,
    HStack,
    Text,
    VStack,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CategoryContainer } from '../components/LandingPageComponents/styles/SplashStyles';
import { backbtn, stepper } from './dashboard/components/Icons';
import { Backbutton } from 'components/LandingPageComponents/styles/HeaderStyles';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { get_categories } from 'redux/actions/productActions';
import { useScreenWidth } from 'hooks/useScreenWidth';
import Loader from 'components/loader';

const ChooseCategory = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [categoryChoices, setCategoryChoices] = useState([]);
    const screen = useScreenWidth();
    const { loading, categories } = useSelector((state) => state.productReducer);

    const handleClick = (value) => {
        // If category is already selected, remove it
        if (categoryChoices.includes(value)) {
            setCategoryChoices(categoryChoices.filter((cat) => cat !== value));
        }
        // If less than 5 categories are selected, add the new category
        else if (categoryChoices.length < 5) {
            setCategoryChoices([...categoryChoices, value]);
        }
    };

    const handleClearSelection = () => {
        if (categoryChoices.length === categories?.length) {
            setCategoryChoices([]);
        } else {
            setCategoryChoices(categories?.map((cat) => cat.name));
        }
    };

    useEffect(() => {
        if (isEmpty(categories)) {
            dispatch(get_categories());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [categories]);

    if (loading) {
        return <Loader />;
    }

    return (
        <CategoryContainer>
            <HStack
                justify="space-between"
                px="27px"
                alignItems="center"
                display={{ base: 'flex', lg: 'none', sm: 'flex' }}>
                <Backbutton onClick={() => navigate(-1)}>{backbtn}</Backbutton>
                <div className="menuSection">{stepper}</div>
                <div>
                    {categoryChoices.length > 0 && (
                        <Text
                            color="#979C9E"
                            fontSize="14px"
                            onClick={handleClearSelection}
                            cursor="pointer">
                            Clear Selection
                        </Text>
                    )}
                </div>
            </HStack>
            <Flex
                w={{ base: 'full', lg: '450px' }}
                mt={{ base: '0', lg: '80px' }}
                h="full"
                mx={{ base: 'auto' }}
                justify="center"
                alignItems="center"
                flexDir="column">
                <Heading
                    as="h2"
                    w="90%"
                    mt="25px"
                    mb="5px"
                    color="#090A0A"
                    fontSize={{ lg: '32px', base: '24px' }}
                    textAlign="center"
                    lineHeight={{ base: '32px', lg: '36px' }}>
                    Choose your Favourite Category{' '}
                </Heading>{' '}
                <Text
                    color="#6C7072"
                    fontSize="16px"
                    lineHeight="24px"
                    mt={{ base: '0', md: '20px' }}>
                    You can Select more Than One, Max of 5{' '}
                </Text>
                <Box
                    border={{ base: 'none', lg: '1px solid #F2F4F5' }}
                    w={{ base: '90%' }}
                    mx="auto"
                    mt={{ base: '0', md: '24px' }}
                    padding={{ base: '0', md: '35px 30px' }}>
                    <VStack
                        w="full"
                        gap="5px"
                        mt="15px"
                        mb="15px"
                        mx="auto"
                        minH={{ base: '400px', lg: 'auto' }}
                        overflowY={{ base: 'scroll', lg: 'visible' }}>
                        <Button
                            w="full"
                            className={categoryChoices.length === 0 ? 'not-selected' : 'selected'}
                            onClick={handleClearSelection}
                            justifyContent={'flex-start'}
                            disabled={categories?.length === 0}>
                            <Checkbox
                                isChecked={categoryChoices.length === categories?.length}
                                borderColor={'#1b3b5f'}
                                pointerEvents="none" // Prevent checkbox from interfering with button click
                                mr={2}
                            />
                            All
                        </Button>
                        {categories?.map((ch) => (
                            <Button
                                w="full"
                                colorScheme="grey"
                                bg="#F2F4F5"
                                className={
                                    categoryChoices.includes(ch.name) ? 'selected' : 'not-selected'
                                }
                                disabled={
                                    categoryChoices.length >= 5
                                        ? !categoryChoices.includes(ch.name)
                                            ? true
                                            : false
                                        : false
                                }
                                justifyContent={'flex-start'}
                                key={ch.category_id}
                                onClick={() => {
                                    handleClick(ch.name);
                                }}>
                                <Checkbox
                                    isChecked={categoryChoices.includes(ch.name)}
                                    borderColor={'#1b3b5f'}
                                    pointerEvents="none" // Prevent checkbox from interfering with button click
                                    mr={2}
                                />
                                {ch.name}
                            </Button>
                        ))}
                    </VStack>
                    <Button
                        className="btn"
                        disabled={categoryChoices.length === 0}
                        onClick={() =>
                            navigate(screen > 500 ? '/dashboard/actions' : '/actions', {
                                replace: true,
                            })
                        }>
                        Proceed
                    </Button>
                </Box>
            </Flex>
        </CategoryContainer>
    );
};

export default ChooseCategory;
